const configInformation = {
    file:{
        getFunc:'getFile',
        detailApiParamSet:{
            a_container_id:1,
        },
    },
    banner:{
        getFunc:'getFile',
        detailApiParamSet:{
            a_container_id:1,
        },
    },

}
export default {
    methods: {
        returnInformationConfig(type) {
            return configInformation[type];
        }
    }
}
